import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Banknote } from 'lucide-react'
import { formatCurrency } from '@/lib/utils'

export default function PagarDialog({
  open,
  onOpenChange,
  target, // { tipo: 'processo'|'parcela', numero_processo, parcela_numero?, numero_parcelas?, valor? }
  dataPagamento,
  setDataPagamento,
  onSubmit,
}) {
  const isParcela = target?.tipo === 'parcela'
  const titulo = isParcela
    ? `Pagar Parcela ${target.parcela_numero}/${target.numero_parcelas}`
    : 'Pagar Processo'

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Banknote className="w-5 h-5 text-emerald-600" />
            {titulo}
          </DialogTitle>
          <DialogDescription>
            {target?.numero_processo && (
              <span>
                Processo: <strong>{target.numero_processo}</strong>
                {target.valor != null && (
                  <> — Valor: <strong className="text-teal-700">{formatCurrency(target.valor)}</strong></>
                )}
              </span>
            )}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="data_pagamento">Data do Pagamento</Label>
            <Input
              id="data_pagamento"
              type="date"
              value={dataPagamento}
              onChange={(e) => setDataPagamento(e.target.value)}
              required
              autoFocus
              data-testid="input-data-pagamento"
            />
            <p className="text-xs text-slate-500">Por padrão a data de hoje é sugerida, mas você pode alterar.</p>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Cancelar
            </Button>
            <Button type="submit" className="bg-emerald-600 hover:bg-emerald-700" data-testid="confirmar-pagar-btn">
              <Banknote className="w-4 h-4 mr-2" />
              Confirmar Pagamento
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}
